import { useState } from 'react';
import { Card } from '../../../shared/components/ui/Card';
import PotentialValueModal from './PotentialValueModal';
import { Info } from 'lucide-react';

interface AudienceStatsProps {
    totalUsers: number;
    databaseValue: number;
    potentialDatabaseValue?: number;
    potentialGrowthPercentage?: number;
    showTutorial?: boolean;
}

const AudienceStats = ({
    totalUsers,
    databaseValue,
    potentialDatabaseValue = 0,
    potentialGrowthPercentage = 0,
    showTutorial
}: AudienceStatsProps) => {
    const [showBreakdown, setShowBreakdown] = useState(false);

    return (
        <>
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                <Card
                    className="p-4 flex flex-col justify-between"
                    showTutorial={showTutorial}
                    hideTutorialIcon={true}
                    tutorial="Cantidad total de clientes identificados en tu ecosistema digital."
                >
                    <span className="text-xs text-slate-500 uppercase font-bold tracking-wider">Total Usuarios</span>
                    <span className="text-2xl font-bold text-slate-900">{totalUsers.toLocaleString()}</span>
                </Card>
                <Card
                    className="p-4 flex flex-col justify-between"
                    showTutorial={showTutorial}
                    hideTutorialIcon={true}
                    tutorial="El valor de vida total acumulado de los clientes. Representa el potencial económico de tu audiencia."
                >
                    <span className="text-xs text-slate-500 uppercase font-bold tracking-wider">Valor de tu base de datos</span>
                    <span className="text-2xl font-bold text-blue-600">
                        {databaseValue.toLocaleString('es-AR', { style: 'currency', currency: 'ARS' })}
                    </span>
                </Card>
                <Card
                    className="p-4 flex flex-col justify-between relative group overflow-hidden"
                    showTutorial={showTutorial}
                    hideTutorialIcon={true}
                    tutorial="Este es el valor proyectado de tu base aplicando 3 vectores estratégicos: Reactivación, Frecuencia y Ticket."
                >
                    <div>
                        <div className="flex justify-between items-start">
                            <span className="text-xs text-slate-500 uppercase font-bold tracking-wider">Valor Potencial Base</span>
                            <button
                                type="button"
                                onClick={() => setShowBreakdown(true)}
                                className="text-violet-500 hover:text-violet-700 transition-colors z-10"
                                title="Ver desglose"
                                aria-label="Ver desglose del cálculo"
                            >
                                <Info size={16} />
                            </button>
                        </div>
                        <div className="flex items-center gap-2 mt-1">
                            <span className="text-2xl font-bold text-slate-900">
                                {potentialDatabaseValue.toLocaleString('es-AR', { style: 'currency', currency: 'ARS' })}
                            </span>
                            {potentialGrowthPercentage > 0 && (
                                <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800 animate-pulse">
                                    +{potentialGrowthPercentage}%
                                </span>
                            )}
                        </div>
                        {/* <button
                            onClick={() => setShowBreakdown(true)}
                            className="text-[10px] text-slate-400 hover:text-violet-600 underline decoration-dotted underline-offset-2 mt-1 z-10 relative"
                        >
                            Ver desglose del cálculo
                        </button> */}
                    </div>
                    {/* Visual indicator of growth potential */}
                    <div className="bg-gradient-to-r from-transparent to-green-50/50 absolute bottom-0 right-0 w-1/2 h-full -skew-x-12 opacity-50 pointer-events-none"></div>
                </Card>
                <Card
                    className="p-4 flex flex-col justify-between"
                    showTutorial={showTutorial}
                    hideTutorialIcon={true}
                    tutorial="Progreso de captura de datos comparado con tus metas mensuales de crecimiento."
                >
                    <span className="text-xs text-slate-500 uppercase font-bold tracking-wider">Usuarios en campañas</span>
                    <span className="text-2xl font-bold text-slate-900">0</span>
                </Card>
            </div>

            {/* Modal de Desglose */}
            {showBreakdown && (
                <PotentialValueModal onClose={() => setShowBreakdown(false)} />
            )}
        </>
    );
};

export default AudienceStats;
